import { createFileRoute, redirect } from "@tanstack/react-router";
import { STUDYGROUP_MEMBERSHIP_STATUS_MEMBER } from "@/constants";
import { studyGroupsApi } from "@/lib/humhub-api/studyGroups";
import { studyGroupMembershipApi } from "@/lib/humhub-api/studyGroupMembership";
import {
  getLastStudyGroupId,
  setLastStudyGroupId,
} from "@/lib/storage/studyGroupStorage";

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    // 1. localStorage から studyGroupId を取得してチェック
    const cachedStudyGroupId = getLastStudyGroupId();
    if (cachedStudyGroupId) {
      try {
        // キャッシュされたグループのメンバーシップが有効か検証
        const membership =
          await studyGroupMembershipApi.getStudyGroupYourMembership(
            cachedStudyGroupId,
          );
        const isMember =
          membership.status === STUDYGROUP_MEMBERSHIP_STATUS_MEMBER;
        if (!isMember) {
          throw new Error("Cached study group membership is not active");
        }

        throw redirect({
          to: "/study-group/$study-group-id/stream",
          params: { "study-group-id": String(cachedStudyGroupId) },
          replace: true,
        });
      } catch (error) {
        // リダイレクトオブジェクトはそのまま伝播させる
        if (error && typeof error === "object" && "isRedirect" in error) {
          throw error;
        }
        // キャッシュされたグループにアクセスできない場合はクリアして次の候補へ
        console.warn(
          "Failed to use cached study group, falling back to the latest group",
          error,
        );
        setLastStudyGroupId(null);
      }
    }

    // 2. localStorage にデータがない、または無効な場合は API から取得
    try {
      const response = await studyGroupsApi.getMyStudyGroups(1, 1);

      if (response.results && response.results.length > 0) {
        const firstGroup = response.results[0];

        // API から取得したデータでリダイレクト
        throw redirect({
          to: "/study-group/$study-group-id/stream",
          params: { "study-group-id": String(firstGroup.id) },
          replace: true,
        });
      }
    } catch (apiError) {
      // リダイレクトエラーは再スロー
      if (
        apiError &&
        typeof apiError === "object" &&
        "isRedirect" in apiError
      ) {
        throw apiError;
      }
      // API エラーは無視して次の処理に進む
      console.warn(
        "Failed to fetch study groups from API, redirecting to event-search",
      );
    }

    // 3. すべて失敗した場合は event-search にリダイレクト
    throw redirect({
      to: "/event-search",
      replace: true,
    });
  },
  component: () => <div>Redirecting...</div>,
});
